import {NgModule} from '@angular/core';
import {IonicPageModule} from 'ionic-angular';
import {PipesModule} from "../../../../shared/pipes/pipes.module";
import {BadgeAchievedPage} from "./badge-achieved";

@NgModule({
  declarations: [
    BadgeAchievedPage,
  ],
  imports: [
    PipesModule,
    IonicPageModule.forChild(BadgeAchievedPage),
  ],
})
export class BadgeAchievedPageModule {}



// WEBPACK FOOTER //
// ./src/modules/core/pages/badge-achieved/badge-achieved.module.ts